<template>
  <div v-if="multiSectionList && multiSectionList.length > 0" :key="$route.fullPath">
      <section v-for="(sectionInfo, index) in multiSectionList"
           :class="getCustomWrapperClass(sectionInfo)"
           :key="sectionInfo.title + $route.name + index">
        <DynamicSectionLoader :section-info="sectionInfo" :multisection-index="index"/>
      </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import _ from 'lodash'

export default {
  name: 'SuperMultiSection',
  components: { DynamicSectionLoader },
  computed: {
    ...mapGetters(['multiSectionList'])
  },
  methods: {
    getCustomWrapperClass (sectionInfo) {
      if (_.get(sectionInfo, 'cell_type', '') === 'band_61') return 'ppv-wrap'
      else return ''
    }
  }
}
</script>
